import * as Yup from 'yup';

import { formatPhoneNumber } from '../../utils/util';

import AllInclusiveRoundedIcon from '@mui/icons-material/AllInclusiveRounded';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import UnpublishedRoundedIcon from '@mui/icons-material/UnpublishedRounded';
import TimelapseRoundedIcon from '@mui/icons-material/TimelapseRounded';
import QuestionAnswerRoundedIcon from '@mui/icons-material/QuestionAnswerRounded';

import { Badge } from '@mui/material';

const headers = [
  {
    label: 'Customer',
    id: 'customer_name'
  },
  {
    label: 'Body',
    id: 'text',
    truncate: 30
  },
  {
    label: 'Number',
    id: 'customer_phone',
    render: (row) => formatPhoneNumber(row.customer_phone)
  },
  {
    label: "Type",
    id: "message_type",
    multi: true,
    values: [{ value: "notification", label: "Notification", status: "info" }, { value: "reminder", label: "Reminder", status: "warning" }, { value: "conversation", label: "Conversation", status: "success" }]
  },
  {
    label: "Direction",
    id: "direction",
    multi: true,
    values: [{ label: "Inbound", value: "inbound", status: "success" }, { label: "Outbound", value: "outbound", status: "info" }]
  },
  {
    label: "Date",
    dateTime: true,
    id: "timestamp"
  },
  {
    label: "Unread",
    id: "unread_count",
    render: (row) => row.is_unread ? <Badge badgeContent={row.unread_count} color="secondary" sx={{ ml: 1.3 }} /> : <CheckCircleOutlineRoundedIcon color="success" />
  }
];

const mobile_headers = [
  {
    label: 'Customer',
    id: 'customer_name'
  },
  {
    label: 'Body',
    id: 'text'
  },
  {
    label: "Direction",
    id: "direction",
    multi: true,
    values: [{ label: "Inbound", value: "inbound", status: "success" }, { label: "Outbound", value: "outbound", status: "info" }]
  },
  {
    label: "Date",
    date: true,
    id: "timestamp"
  },
  {
    label: "Unread",
    id: "unread_count",
    render: (row) => row.is_unread ? <Badge badgeContent={row.unread_count} color="secondary" sx={{ ml: 1.3 }} /> : <CheckCircleOutlineRoundedIcon color="success" />
  }
]

const tabs = [
  {id: "conversation", label: "Conversation", Icon: QuestionAnswerRoundedIcon },
  {id: "all", label: "All Messages", Icon: AllInclusiveRoundedIcon },
]

const filters = [
  {
    label: 'Date',
    id: 'date',
    type: "date",
  }
]

export { mobile_headers, headers, filters, tabs };